import apiRequestType from "../../apiRequestType";
import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";

const getTenantPollUsers = (id, time) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.SOCIAL.TENANT_POLLU_USERS_INFO
  );
};

export default getTenantPollUsers;
